import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AnnouncementsSection } from './components/AnnouncementsSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
export function App() {
  return <>
      <style dangerouslySetInnerHTML={{
      __html: `
        html {
          scroll-behavior: smooth;
        }
        /* Custom scrollbar for a more polished feel */
        ::-webkit-scrollbar {
          width: 10px;
        }
        ::-webkit-scrollbar-track {
          background: var(--background);
        }
        ::-webkit-scrollbar-thumb {
          background: #006233;
          border-radius: 5px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #004d28;
        }
      `
    }} data-id="element-0" />
      <div className="min-h-screen bg-background text-foreground flex flex-col font-sans selection:bg-[#006233] selection:text-white" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-1 w-full overflow-x-hidden" data-id="element-3">
          <HeroSection data-id="element-4" />
          <AnnouncementsSection data-id="element-5" />
          <ServicesSection data-id="element-6" />
          <AboutSection data-id="element-7" />
        </main>
        <Footer data-id="element-8" />
      </div>
    </>;
}